import Vue from 'vue';
import x5GMaps from 'x5-gmaps';

/**
 * Documentation: https://xon52.github.io/x5-gmaps/
*/

interface X5Options {
  key: string;
  /** https://developers.google.com/maps/documentation/javascript/libraries */
  libraries: ('' | 'drawing' | 'geometry' | 'localContext' | 'places' | 'visualization')[];
}

Vue.use(
  x5GMaps,
  {
    key: 'AIzaSyAHeHgK43D5QUVtW4thRnZJ9Cwj-Jn1Gx0',
    libraries: [''],
  } as X5Options,
);
